// Whether the side panel of the pages (components/NewsLayout.tsx) is open:
// one state for the whole session, held by Providers (src/app/providers.tsx).
// Closed when the app opens; open once, it stays open on every page until the
// user closes it or reloads the page. In memory only: nothing in localStorage.
import { createContext, useContext } from "react";

export type SidePanelState = { open: boolean; setOpen: (open: boolean) => void };

export const SidePanelContext = createContext<SidePanelState | null>(null);

export function useSidePanel(): SidePanelState {
  const state = useContext(SidePanelContext);
  if (!state) throw new Error("useSidePanel needs Providers (src/app/providers.tsx)");
  return state;
}
